// extracted by mini-css-extract-plugin
module.exports = {"sideBarCard":"blog_sideBarCard__GEF6U","titleCategories":"blog_titleCategories__ddrP9","categoryList":"blog_categoryList__0UBr5"};